const Colors = {
    Elmt: {
        White: 0xffffff,
        Yellow: 0xdba94e,
        LightBlue: 0x3ae1d8,
        MediumBlue: 0x008fed,
        Blue: 0x0d2863,
        Violet: 0x8000ff,
        LightGreen: 0xd0ffeb,
        Green: 0x3be39d,
        Red: 0xff6c6c,
        DarkRed: 0xc6a6d4,
        Gray: 0x1e1e1e,
        Black: 0x000000,
    },
    Text: {
        White: '#ffffff',
        Yellow: '#DBA94E',
        LightBlue: '#3AE1D8',
        MediumBlue: '#008FED',
        Blue: '#0D2863',
        Violet: '#8000ff',
        LightGreen: '#D0FFEB',
        Green: '#3BE39D',
        Red: '#FF6C6C',
        DarkRed: '#C6A6D4',
        Gray: '#1E1E1E',
        Black: '#000000',
    },
};

export { Colors };
